import { Icon as IconifyIcon } from '@iconify/react'
import { useSet, useLastResolved } from 'ccstate-react'
import { searchHistory$ } from '../state'
import { navigateInReact$ } from '../infra/router/navigate'
import TabBar from '../components/TabBar'
export default function HistoryPage() {
  const history = useLastResolved(searchHistory$) || []
  const navigate = useSet(navigateInReact$)
  const handleHistoryClick = (word: string) => {
    navigate(`/word/${word}` as '/word/:word')
  }
  return (<div className="min-h-screen bg-[#F7F8FA] pb-20" data-id="464qqv">
    <div className="p-4" data-id="9askxu">
      {/* Page Title */}
      <h1 className="text-xl font-semibold text-[#1A1A1A] mb-6" data-id="862pwo">历史记录</h1>

      {/* History List */}
      {history.length > 0 ? (<div className="border border-[#D4DBE6] rounded-md bg-[#F7F8FA]" data-testid="history-list" data-id="pmhupu">
        {history.map((item, index) => (<button key={item.id} onClick={() => handleHistoryClick(item.word)} className={`w-full text-left px-4 py-4 ${index !== history.length - 1 ? 'border-b border-[#E8EDF3]' : ''} hover:bg-[#E8EDF3] transition-colors`} data-testid={`history-${item.word}`} data-id="lq39mh">
          <div className="flex justify-between items-start" data-id="h1telv">
            <div className="flex-1" data-id="h2tj2o">
              <div className="text-base font-medium text-[#1A1A1A] mb-1" data-id="ydp2ir">
                {item.word}
              </div>
              <div className="text-sm text-[#5A6B7D] mb-1" data-id="0z3fva">
                {item.briefMeaning}
              </div>
              <div className="text-xs text-[#9BA8B8]" data-id="qxwboy">
                {new Date(item.searchedAt).toLocaleString('zh-CN', {
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </div>
            </div>
            <IconifyIcon icon="lucide:chevron-right" className="text-xl text-[#9BA8B8] ml-2" data-id="t4fohr"/>
          </div>
        </button>))}
      </div>) : (
        /* Empty State */
        <div className="flex flex-col items-center justify-center mt-32" data-id="fhkwuy">
          <IconifyIcon icon="lucide:clock" className="text-[80px] text-[#D4DBE6] mb-4" data-id="q9h2hf"/>
          <p className="text-base text-[#5A6B7D] mb-2" data-id="h1ouwq">暂无历史记录</p>
          <p className="text-sm text-[#9BA8B8]" data-id="46urqv">去查词页搜索单词吧</p>
        </div>)}
    </div>

    <TabBar data-id="8ibnos"/>
  </div>)
}
